import { createSelector } from 'reselect'

import { IApplicationState } from '@store'
import { IAudienceInsights, IBrandConnectAudienceInsight } from '@store/audienceInsights'

export const selectAudienceInsights = createSelector(
  (state: IApplicationState) => state.audienceInsights,
  (state: IApplicationState, identityId: number) => identityId,
  (audienceInsights, identityId: number) =>
    audienceInsights.audienceInsightsByIdentityId[identityId] || ({} as IAudienceInsights),
)

export const selectAudienceInsightsIsFetching = (state: IApplicationState) =>
  state.audienceInsights.isFetching

export const selectAudienceInsightsFilters = (state: IApplicationState) =>
  state.audienceInsights.filters

export const selectBrandConnectAudienceInsights = createSelector(
  (state: IApplicationState) => state.audienceInsights.brandConnectAudienceInsightsById,
  (state: IApplicationState) => state.audienceInsights.filters,
  (state: IApplicationState, submissionId: number) => submissionId,
  (brandConnectInsightsById, filters, submissionId): IBrandConnectAudienceInsight | null => {
    const brandConnectData = brandConnectInsightsById[submissionId]

    if (!Array.isArray(brandConnectData)) {
      return null
    }

    if (brandConnectData.length === 0) {
      return null
    }

    const filterEntries = Object.entries(filters || {})

    // Filter the array based on all filter entries
    let selectedInsight = brandConnectData[0]
    if (filterEntries.length > 0) {
      const filtered = brandConnectData.filter((insight) =>
        filterEntries.every(([key, value]) => insight[key] === value),
      )
      selectedInsight = filtered.length > 0 ? filtered[0] : null
    }

    if (!selectedInsight) {
      return null
    }

    // Transform to IBrandConnectAudienceInsight format with all fields
    return {
      identity_id: selectedInsight.identity_id,
      period: selectedInsight.period,
      content_type: selectedInsight.content_type,
      traffic_source: selectedInsight.traffic_source,
      gender: [...(selectedInsight.gender || [])],
      age_range: [...(selectedInsight.age_range || [])],
      top_countries: [...(selectedInsight.top_countries || [])],
      top_cities: [...(selectedInsight.top_cities || [])],
      shopping_interests: [...(selectedInsight.shopping_interests || [])],
      watch_interests: [...(selectedInsight.watch_interests || [])],
      affinity_interests: [...(selectedInsight.affinity_interests || [])],
      in_market_interests: [...(selectedInsight.in_market_interests || [])],
    }
  },
)
